import { IssueTypes } from '../../../cimsPage/instances/issues'
import { CreateViewEditSoftRemoveRestore } from '../../common'

const { Create, Edit, RemoveRestore, View } = CreateViewEditSoftRemoveRestore({
  page: IssueTypes,
  object: 'Type',
  create: '00681623-990F-4598-A811-161506A452D2',
  edit: 'EB1818F0-6236-42DF-B5E3-823FB51CE3E8',
  removeRestore: '10C59E84-2255-4C16-BAC8-8234A2429404',
  view: '8C9EA5C3-75A3-4CCC-9E06-91D89C3E0437',
})

export const CreateIssueType = Create
export const EditIssueType = Edit
export const RemoveRestoreIssueType = RemoveRestore
export const ViewIssueType = View

export type IssueTypePermission =
  | typeof CreateIssueType
  | typeof EditIssueType
  | typeof RemoveRestoreIssueType
  | typeof ViewIssueType
